import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const languageSwitcherTranslationRef = createTranslationRef({
  id: 'app.languageSwitcher',
  messages: {
    label: {
      selectLanguage: 'Select Language',
      language: 'Language',
    },
    language: {
      en: 'English',
      ptBR: 'Português (Brasil)',
    },
  },
});
